import Vue from 'vue'
import Router from 'vue-router'
import Scene from '@/pages/scene/Scene'
import Home from '@/pages/home/Home'
import About from '@/pages/about/About'
import Main from '@/pages/main/Main'
import Join from '@/pages/join/Join'
import News from '@/pages/news/News'
import Contact from '@/pages/contact/Contact'
import Quality from '@/pages/quality/Index'
import aboutInfo from '@/pages/about/components/Info'
import aboutSign from '@/pages/about/components/Sign'
import aboutIdea from '@/pages/about/components/Idea'
import aboutHistory from '@/pages/about/components/doubleSwiper'
import mainSzBABHJH from '@/pages/main/components/szBABHJH'
import mainHPDF from '@/pages/main/components/hpDF'
import mainFSDF from '@/pages/main/components/fsDF'
import mainGZDH from '@/pages/main/components/gzDH'
import mainGZDF from '@/pages/main/components/gzDF'
import mainCDYQC from '@/pages/main/components/cdYQC'
import mainJMJTW from '@/pages/main/components/jmYTW'
import mainTeam1 from '@/pages/main/components/Team1'
import mainTeam2 from '@/pages/main/components/Team2'
import mainTeam3 from '@/pages/main/components/Team3'
import mainTeamFS from '@/pages/main/components/TeamFS'
import mainTeamZH from '@/pages/main/components/TeamZH'
import mainHotel from '@/pages/main/components/Hotel'
import mainMarket from '@/pages/main/components/Market'
import mainProperty from '@/pages/main/components/Property'
import newsSwiper from '@/pages/news/components/doubleSwiper'
import contactMain from '@/pages/contact/components/Contact'
// import joinCulture from '@/pages/join/components/Culture'
import joinIdea from '@/pages/join/components/Idea'
import joinStatement from '@/pages/join/components/Statement'
import joinLegal from '@/pages/join/components/Legal'
import joinPosition from '@/pages/join/components/Position'
import qualityDesign from '@/pages/quality/components/Design'
import qualityBuy from '@/pages/quality/components/Buy'
import qualityWork from '@/pages/quality/components/Work'
import qualityTest from '@/pages/quality/components/Test'
import qualityServe from '@/pages/quality/components/Serve'

Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'scene',
      component: Scene
    },
    {
      path: '/home',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About,
      children: [
        {path: '/', component: aboutInfo},
        {path: 'sign', component: aboutSign},
        {path: 'idea', component: aboutIdea},
        {path: 'history', component: aboutHistory}
      ]
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      children: [
        {path: '/', component: mainHPDF},
        {path: 'hpdf', component: mainHPDF},
        {path: 'fsdf', component: mainFSDF},
        {path: 'gzdh', component: mainGZDH},
        {path: 'gzdf', component: mainGZDF},
        {path: 'cdyqc', component: mainCDYQC},
        {path: 'jmjtw', component: mainJMJTW},
        {path: 'team1', component: mainTeam1},
        {path: 'team2', component: mainTeam2},
        {path: 'team3', component: mainTeam3},
        {path: 'teamfs', component: mainTeamFS},
        {path: 'teamzh', component: mainTeamZH},
        {path: 'hotel', component: mainHotel},
        {path: 'market', component: mainMarket},
        {path: 'property', component: mainProperty},
        {path: 'szbabhjh', component: mainSzBABHJH}
      ]
    },
    {
      path: '/news',
      name: 'news',
      component: News,
      children: [
        {path: '/', component: newsSwiper}
      ]
    },
    {
      path: '/join',
      name: 'join',
      component: Join,
      children: [
        {path: '/', component: joinIdea},
        // {path: 'idea', component: joinIdea},
        {path: 'statement', component: joinStatement},
        {path: 'legal', component: joinLegal},
        {path: 'position', component: joinPosition}
      ]
    },
    {
      path: '/contact',
      name: 'contact',
      component: Contact,
      children: [
        {path: '/', component: contactMain}
      ]
    },
    {
      path: '/quality',
      name: 'quality',
      component: Quality,
      children: [
        {path: '/', component: qualityBuy},
        {path: 'design', component: qualityDesign},
        {path: 'work', component: qualityWork},
        {path: 'test', component: qualityTest},
        {path: 'serve', component: qualityServe}
      ]
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js